import moment from 'moment-timezone'

import { AwairRthOccurrence, AwairRthTrace } from 'types/AwairRuntimeHistory'

const parseTimeZone = (timestamp, timeZone, addMilliseconds = 0) => {
  const t = moment.unix(timestamp).tz(timeZone)

  return t.add(addMilliseconds, 'milliseconds').format('YYYY-MM-DDTHH:mm:ss.SSS')
}

export const createAwairRthTrace = (series: AwairRthOccurrence[] = [], timezone: string, callback?: (input: number | boolean | string | undefined) => number | null): AwairRthTrace => {
  const occurrences: Array<string> = []
  const values: Array<number | null> = []

  for (const entry of series) {
    occurrences.push(parseTimeZone(entry.occurredAt, timezone))

    if (callback) {
      values.push(callback(entry.value))
    } else {
      values.push(typeof entry.value === 'number' ? entry.value : null)
    }
  }

  return {
    occurrences,
    values
  }
}
